/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerOrderItemsByCustomerOrderSummary,
  PagedResultCustomerOrderItemSummary,
  SortDirection,
} from '../models/index';
import {
    CustomerOrderItemsByCustomerOrderSummaryFromJSON,
    CustomerOrderItemsByCustomerOrderSummaryToJSON,
    PagedResultCustomerOrderItemSummaryFromJSON,
    PagedResultCustomerOrderItemSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetCustomerOrderItemSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    productNumber?: string;
    fulltextQuery?: string;
    sortByProductNumber?: SortDirection;
    sortByHeoItemId?: SortDirection;
    sortByCustomerOrderCreatedAt?: SortDirection;
    sortByCustomerOrderNumber?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByAcceptedQuantity?: SortDirection;
    sortByPricePerUnit?: SortDirection;
    sortByTotal?: SortDirection;
    sortByDiscount?: SortDirection;
    sortByCustomerReference?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
}

export interface GetCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequest {
    customerOrderId: string;
}

/**
 * 
 */
export class CustomerOrderItemResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getCustomerOrderItemSummariesOfCurrentRetailer without sending the request
     */
    async getCustomerOrderItemSummariesOfCurrentRetailerRequestOpts(requestParameters: GetCustomerOrderItemSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['productNumber'] != null) {
            queryParameters['productNumber'] = requestParameters['productNumber'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByHeoItemId'] != null) {
            queryParameters['sortByHeoItemId'] = requestParameters['sortByHeoItemId'];
        }

        if (requestParameters['sortByCustomerOrderCreatedAt'] != null) {
            queryParameters['sortByCustomerOrderCreatedAt'] = requestParameters['sortByCustomerOrderCreatedAt'];
        }

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByAcceptedQuantity'] != null) {
            queryParameters['sortByAcceptedQuantity'] = requestParameters['sortByAcceptedQuantity'];
        }

        if (requestParameters['sortByPricePerUnit'] != null) {
            queryParameters['sortByPricePerUnit'] = requestParameters['sortByPricePerUnit'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByDiscount'] != null) {
            queryParameters['sortByDiscount'] = requestParameters['sortByDiscount'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/customer-order-items`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCustomerOrderItemSummariesOfCurrentRetailerRaw(requestParameters: GetCustomerOrderItemSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedResultCustomerOrderItemSummary>> {
        const requestOptions = await this.getCustomerOrderItemSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedResultCustomerOrderItemSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerOrderItemSummariesOfCurrentRetailer(requestParameters: GetCustomerOrderItemSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedResultCustomerOrderItemSummary> {
        const response = await this.getCustomerOrderItemSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCustomerOrderItemsByCustomerOrderOfCurrentRetailer without sending the request
     */
    async getCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequestOpts(requestParameters: GetCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderItemsByCustomerOrderOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/customer-order-items/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCustomerOrderItemsByCustomerOrderOfCurrentRetailerRaw(requestParameters: GetCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerOrderItemsByCustomerOrderSummary>>> {
        const requestOptions = await this.getCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerOrderItemsByCustomerOrderSummaryFromJSON));
    }

    /**
     */
    async getCustomerOrderItemsByCustomerOrderOfCurrentRetailer(requestParameters: GetCustomerOrderItemsByCustomerOrderOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerOrderItemsByCustomerOrderSummary>> {
        const response = await this.getCustomerOrderItemsByCustomerOrderOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
